import React, { PureComponent } from "react";
import "./index.css";
import Slider from "../../components/Sliders/Slider";
import Logs from "../Logs/index";
import InfoCard from "../InfoCard/index";
import SliderSmall from "../../components/Sliders/SliderSmall";

class Kryefaqe extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    var pageSize = window.innerWidth;
    return (
      <div className="kryefaqe-container">
        {pageSize >= 870 ? <Slider /> : <SliderSmall />}

        <div className="logs">
          {" "}
          <Logs />
        </div>
        <div className="info-card">
          <InfoCard />
        </div>
      </div>
    );
  }
}

Kryefaqe.propTypes = {};

export default Kryefaqe;
